const Copyright = () => {
    return(
        <>
            © 2024 by ParacuruTec. All rights reserved.
        </>
    )
}

export default Copyright